import {FormatterBasic} from "./Core/FormatterBasic";

export class ComposedFormatter extends FormatterBasic {
    Format(): string {
        let value=this.GetValue('Value');
        let items:{
            Id:string,
            Path:string[],
            Label:string,
            AddCommaBefore:boolean
        }[]=(this.Field as any).Items;


        let text='';
        for(let currentItem of items)
        {
            text=this.AddItem(currentItem,value,text);
        }
        return text;
    }

    private AddItem(currentItem: { Id: string; Path: string[]; Label: string; AddCommaBefore: boolean }, value: any,text:string) {
        let currentPath;
        for(let currentPath of currentItem.Path)
        {
            if(typeof value[currentPath]=="undefined")
            {
                value='';
                break;
            }

            value=value[currentPath];
        }

        value=value.toString();

        if(value=='')
            return text;

        if(text!='')
        {
            if(currentItem.AddCommaBefore)
                text+=', ';
            else
                text+=' ';
        }

        text+=value;
        return text;




    }
}